import styled from "styled-components";

// Mission Details Timeline Styles
export const MissionDetailsTimelineWrapper = styled.div`
  width: 100%;
  padding: 24px;
  background: transparent;
  border-radius: 8px;
  position: relative;
`;

export const MissionCycleTitle = styled.div`
  color: #767676;
  font-size: 12px;
  font-family: Readex Pro;
  font-weight: 300;
  line-height: 15.6px;
  margin-bottom: 16px;
`;

export const MissionStopsContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const MissionTimelineVerticalLine = styled.div`
  position: absolute;
  left: 6px;
  top: 20px;
  bottom: 5px;
  width: 2px;
  background: #d1d1d1;
`;

export const MissionStopRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  position: relative;
`;

export const MissionStopIcon = styled.div`
  width: 18px;
  height: 20px;
  background: transparent;
  flex-shrink: 0;
  position: relative;
  left: -2px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;

export const MissionStopName = styled.span`
  color: #172a3f;
  font-size: 12px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 15.6px;
  width: 80px;
  flex-shrink: 0;
  margin-top: 4px;
`;

export const MissionStopActionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  margin-top: 2px;
`;

export const MissionStopActionItem = styled.div`
  color: #606060;
  font-size: 14px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 19.6px;
`;

export const MissionTimelineEmptyState = styled.div`
  color: #6c757d;
  text-align: center;
  padding: 40px 20px;
  font-size: 16px;
  font-family: Readex Pro;
`;

export const MissionCycleContainer = styled.div`
  padding-bottom: 32px;

  &:last-child {
    padding-bottom: 0;
  }
`;

// Cycle title styles
export const CycleTitleLabel = styled.span`
  color: #1b1b1b;
  font-size: 16px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 20.48px;
  word-wrap: break-word;
`;

export const CycleNumbersContainer = styled.div`
  justify-content: center;
  align-items: center;
  gap: 4px;
  display: flex;
`;

export const CycleCurrentNumber = styled.span`
  color: #606060;
  font-size: 16px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 20.48px;
  word-wrap: break-word;
`;

export const CycleSeparator = styled.div`
  width: 3px;
  height: 3px;
  background: #d1d1d1;
`;

export const CycleTotalNumber = styled.span`
  color: #606060;
  font-size: 16px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 20.48px;
  word-wrap: break-word;
`;

export const CycleTitleContent = styled.div`
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: flex;
`;

export const CycleTitleWrapper = styled.div`
  flex: 1 1 0;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 15px;
  display: flex;
`;
